import Overlay, { StopPropagation } from '@ynap/overlay';
import { Button } from '@ynap/button';
import React, { useEffect } from 'react';
import { setItemOnWebStorage } from '@ynap/web-storage-utils';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('SuccessModal');

type SuccessModalProps = {
    messages: any;
    onCloseModal: () => void;
    goToWishlist: () => void;
};

const SuccessModal = ({ messages, onCloseModal, goToWishlist }: SuccessModalProps) => {
    useEffect(() => {
        setItemOnWebStorage('sessionStorage', 'AWLsuccessMessage', true);
    }, []);

    return (
        <StopPropagation>
            <Overlay
                onClose={onCloseModal}
                handleBodyClick={onCloseModal}
                title=""
                type="miniDialog"
                className={{ container: bem('successModal'), title: bem('successOverlayTitle'), button: bem('successOverlayClose') }}
            >
                <div className={bem('success')} data-testid="atw_success">
                    <div className={bem('successTitle')}>{messages.productListing.wishList.title()}</div>
                    <div className={bem('successSubTitle')}>{messages.productListing.wishList.subtitle()}</div>
                    <Button type="secondary" component="a" onClick={goToWishlist} className={bem('successButton')}>
                        {messages.productListing.wishList.goToWishlist()}
                    </Button>
                </div>
            </Overlay>
        </StopPropagation>
    );
};

export default SuccessModal;
